import { createSignal, createEffect, For, onMount } from 'solid-js'
import { Portal } from 'solid-js/web'

const [messages, setMessages] = createSignal([])

function Icon(props) {
	const svgClass = 'shrink-0 size-6'
	const sw = '1.75'
	return (
		<>
			{props.level === 'info' || props.level === 'primary' ? (
				<svg class={svgClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={sw} stroke-linecap="round" stroke-linejoin="round">
					<circle cx="12" cy="12" r="10" />
					<line x1="12" y1="16" x2="12" y2="12" />
					<circle cx="12" cy="8" r="0.5" fill="currentColor" />
				</svg>
			) : props.level === 'success' ? (
				<svg class={svgClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={sw} stroke-linecap="round" stroke-linejoin="round">
					<circle cx="12" cy="12" r="10" />
					<path d="M8 12.5l3 3 5-6.5" />
				</svg>
			) : props.level === 'warning' ? (
				<svg class={svgClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={sw} stroke-linecap="round" stroke-linejoin="round">
					<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
					<line x1="12" y1="9" x2="12" y2="13" />
					<circle cx="12" cy="16.5" r="0.5" fill="currentColor" />
				</svg>
			) : (
				<svg class={svgClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={sw} stroke-linecap="round" stroke-linejoin="round">
					<circle cx="12" cy="12" r="10" />
					<line x1="12" y1="8" x2="12" y2="12" />
					<circle cx="12" cy="16" r="0.5" fill="currentColor" />
				</svg>
			)}
		</>
	)
}

const LEVEL_CLASS = {
	primary: 'toast-alert-primary',
	info: 'toast-alert-info',
	success: 'toast-alert-success',
	warning: 'toast-alert-warning',
	error: 'toast-alert-error',
}

export function addToast({ level, message, timeout }) {
	if (level) {
		console.assert(['info', 'success', 'warning', 'error', 'primary'].indexOf(level) > -1)
	}
	const [removing, setRemoving] = createSignal(false)
	const msg = { id: window.crypto.randomUUID(), level: level ?? 'success', message, removing, setRemoving }
	setMessages((e) => {
		e.push(msg)
		while (e.length > 10) {
			e.shift()
		}
		return [...e]
	})
	setTimeout(() => removeToast(msg.id), timeout ?? 3000)
}

function removeToast(id) {
	const item = messages().find((m) => m.id === id)
	if (!item) return
	// 觸發退場動畫
	item.setRemoving(true)
	// 動畫結束後移除 DOM（需與 index.css 中 .toast-exit 動畫時間同步）
	setTimeout(() => {
		setMessages((e) => {
			const i = e.findIndex((m) => m.id === id)
			if (i > -1) e.splice(i, 1)
			return [...e]
		})
	}, 300)
}

export default function Toast() {
	let toastRef

	// 使用 popover API 讓 Toast 進入 top layer
	onMount(() => {
		if (toastRef && toastRef.showPopover) {
			toastRef.showPopover()
		}
	})

	// 當有訊息時，強制重新顯示 popover 確保它在 top layer 最上層
	createEffect(() => {
		const msgCount = messages().length
		if (msgCount > 0 && toastRef) {
			// 先關閉再開啟，確保 popover 在 top layer 的最上層（高於 dialog backdrop）
			if (toastRef.matches(':popover-open')) {
				toastRef.hidePopover?.()
			}
			// 使用 requestAnimationFrame 確保 hidePopover 完成
			requestAnimationFrame(() => {
				toastRef.showPopover?.()
			})
		}
	})

	return (
		<Portal mount={document.body}>
			<div ref={toastRef} popover="manual" class="toast-container">
				<For each={messages()} fallback={<></>}>
					{(e) => (
						<div class={`toast-alert ${LEVEL_CLASS[e.level] || LEVEL_CLASS.info} ${e.removing() ? 'toast-exit' : 'toast-enter'}`}>
							<Icon level={e.level} />
							<span>{e.message}</span>
						</div>
					)}
				</For>
			</div>
		</Portal>
	)
}
